import { makeStyles, Theme } from '@material-ui/core/styles'

interface StyleProps {
  bgColor: string
}

const stylesBlurryLoadingImage = makeStyles<Theme, StyleProps>(() => ({
  divStyle: {
    overflow: 'hidden',
    position: 'relative',
  },
  skeletonBox: {
    position: 'relative',
    width: '150px',
    height: '250px',
  },
  skeleton: (props) => ({
    width: '100%',
    height: '100%',
    backgroundColor: props.bgColor,
  }),
  image: {
    width: '100%',
    height: '100%',
  },
}))

export default stylesBlurryLoadingImage
